import { UrlSegment, UrlMatchResult } from '@angular/router';

// ex: /on
export function provinceMatcher(url: UrlSegment[]): UrlMatchResult {
  const lowerCaseUrl = url[0] ? url[0].path.toLowerCase() : '';
  return url.length === 1 && ['ab', 'bc', 'mb', 'nb', 'nl', 'nt', 'ns', 'nu', 'on', 'pe', 'qc', 'sk', 'yt'].indexOf(lowerCaseUrl) >= 0 ? ({ consumed: url}) : null;
}

// ex: /on/hoda-abu-shabab-p101354257-ag
export function agentProfileMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 2 && url[1].path.endsWith('-ag') ? ({consumed: url}) : null;
}

// ex: /on/re-max-realtron-realty-inc-643-br
export function officeProfileMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 2 && url[1].path.endsWith('-br') ? ({consumed: url}) : null;
}

// ex: /on/toronto-real-estate/3155-eglinton-ave-e-1-wp_id197312002-lst
export function listingDetailsMatcher(url: UrlSegment[]): UrlMatchResult {
  const isMatchingUrl = (url.length === 4 && url[3].path.endsWith('-lst')) || (url.length === 3 && url[2].path.endsWith('-lst'));
  return isMatchingUrl ? ({consumed: url}) : null;
}

export function offMarketListingDetailsMatcher(url: UrlSegment[]): UrlMatchResult {
  const isMatchingUrl = (url.length === 4 && url[3].path.endsWith('-prty')) || (url.length === 3 && url[2].path.endsWith('-prty'));
  return isMatchingUrl ? ({ consumed: url }) : null;
}

// ex: /on/toronto-real-estate
export function cityMatcher(url: UrlSegment[]): UrlMatchResult {
  const isMatchingUrl = (url.length === 3 && url[2].path.endsWith('-real-estate')) || (url.length === 2 && url[1].path.endsWith('-real-estate'));
  return isMatchingUrl ? ({consumed: url}) : null;
}

// ex: /ab/acme-land-for-sale/
export function propTypeMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 2 && url[1].path.endsWith('-for-sale') ? ({consumed: url}) : null;
}

// Ex: /on/toronto-real-estate-agents
export function popularAgentCityMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 2 && url[1].path.endsWith('-real-estate-agents') ? ({consumed: url}) : null;
}

// Ex: commercial/on/toronto-business-opportunities
export function businessOpportunitiesCityMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 3 && url[2].path.endsWith('business-opportunities') ? ({consumed: url}) : null;
}

// Ex: /on/toronto-open-houses
export function openHouseMatcher(url: UrlSegment[]): UrlMatchResult {
  const isMatchingUrl = (url.length === 3 && url[2].path.endsWith('-open-houses')) || (url.length === 2 && url[1].path.endsWith('-open-houses'));
  return isMatchingUrl ? ({consumed: url}) : null;
}
